export default function About() {
  return (
    <section id="about" className="py-32 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-20">
        {/* Title Area */}
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-2 border border-gray-400 rounded-full mb-6">
            <span className="text-xs text-gray-600 tracking-wider">ABOUT US</span>
          </div>
          <h2 className="text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            <span className="font-normal">私たちは</span>
            <br />
            <span className="italic" style={{ fontFamily: "'Noto Serif JP', serif" }}>想い</span>
            <span>をカタチにします</span>
          </h2>
          <div className="mt-6 space-y-2">
            <p className="text-base text-gray-700 font-medium">代表取締役　佐々木伸一</p>
            <p className="text-sm text-gray-500">
              <i className="ri-map-pin-line mr-1"></i>
              〒113-0021　東京都文京区本駒込6-4-9
            </p>
          </div>
        </div>

        {/* Cards Area */}
        <div className="flex gap-[10%] items-stretch">
          {/* Left Card - Philosophy */}
          <div className="w-[45%] bg-[#FF8B6A] rounded-2xl p-12 relative flex flex-col justify-between min-h-[400px]">
            <div className="absolute top-8 right-8">
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full cursor-pointer hover:scale-110 transition-transform">
                <i className="ri-arrow-right-up-line text-[#FF8B6A] text-xl"></i>
              </div>
            </div>
            
            <div>
              <div className="text-white font-bold text-[80px] leading-none mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                真心
              </div>
              <div className="text-white text-2xl font-medium leading-relaxed">
                お客様一人ひとりの<br />
                想いに寄り添って
              </div>
            </div>
            
            <div className="mt-auto">
              <p className="text-white text-sm italic" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                Every moment matters
              </p>
            </div>
          </div>

          {/* Right Card - Company Info */}
          <div className="w-[45%] bg-[#C8B8E6] rounded-2xl p-12 relative flex flex-col justify-between min-h-[400px]">
            <div className="absolute top-8 right-8">
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full cursor-pointer hover:scale-110 transition-transform">
                <i className="ri-arrow-right-up-line text-[#C8B8E6] text-xl"></i>
              </div>
            </div>
            
            <div>
              <div className="text-white font-bold text-[80px] leading-none mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                挑戦
              </div>
              <div className="text-white text-lg font-normal leading-relaxed">
                創業まもない私たちだからこそ、一つひとつのイベントに全力で向き合います
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}